import QuoteConfirmationModalHeader from './components/QuoteConfirmationModalHeader/QuoteConfirmationModalHeader';
import QuoteConfirmationModalBody from './components/QuoteConfirmationModalBody/QuoteConfirmationModalBody';
import './QuoteConfirmationModalContent.scss';

interface IQuoteConfirmationModalContent {
  quoteId: number;
  clientName: string;
  countryName: string;
  countryCode: string;
  quotedToolsCount: number;
  totalAmount: string;
  organizationId?: number;
  onClose: () => void;
  onConfirm: (expirationDate: string) => void;
}

/**
 * Contenido del modal de confirmación de envío de cotización.
 * Compone el encabezado y el cuerpo del modal.
 */
const QuoteConfirmationModalContent = (props: IQuoteConfirmationModalContent) => (
  <div className="quoteConfirmationModalContent">
    <QuoteConfirmationModalHeader onClose={props.onClose} />
    <QuoteConfirmationModalBody {...props} />
  </div>
);

export default QuoteConfirmationModalContent;
